import type { FaireProductEntity } from "../../entity_types/product";

export const p_42twguuyyx: FaireProductEntity = {
  token: "p_42twguuyyx",
  type: "product",
  name: "TB Home 4-Pc. Acacia Wood Cheese Board & Cheese Tool Set",
  brandName: "Totally Bamboo",
  imageUrl:
    "https://cdn.faire.com/fastly/39d23bfc88ed3f5c0528a01fc1a99229f64e678d9ae853e0e2db806f1a81ebf8.jpeg",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/bba4449887c296f484ea27239b134d0ee9be70acd4511a729e27cd50f0eb1aa0.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
